import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-result-analysis',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class ResultAnalysisComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
